// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__B51a7","btn":"PageNotFound_btn__E+Toa"};